import { action } from 'easy-peasy';
import { IActionSetAvailableActTeams } from '../types';

const setAvailableActTeams: IActionSetAvailableActTeams = action((state, payload) => {
  state.availableActTeams = payload;
});

export default setAvailableActTeams;
